import "./../Stylesheets/Main.css"

import { useState } from "react";
import axios from "axios";
import { SHA256 } from "crypto-js";
import { enc } from "crypto-js";


const AdminLogin = () => {

    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false)


    const apiAddress = "https://guidos-fahrradwelt.de/api/admin-authenticate.php"



    const handleChange = (e) => {
        const { name, value } = e.target;
        setPassword(value);
        setError("");
      };

      const handleSubmit = (e) => {
        e.preventDefault();

        setSuccess(false);

        if (password === "") {
          setError("Passwort benötigt")
        }
        let password_encoded = SHA256(password).toString(enc.Base64)
        console.log(password_encoded)
        setIsLoading(true);
        axios
        .post(apiAddress, JSON.stringify(password_encoded))
        .then((res) => {
        console.log(res.data)
        setError("");
        setIsLoading(false);
        setSuccess(true);
        }).catch((error) => {
        console.error("Error submitting form:", error);
        setError("Anmeldung fehlgeschlagen")
            setIsLoading(false);
        });
          
        
      };
    
    return (
        <div className="contact-card-wrapper">
            <h1 className="contact-title card-title-shadow title-left" >
                Login
            </h1>
            <form className="contact-card card-shadow" onSubmit={handleSubmit}>
                <label>
                    Password:
                    {error && (
                    <span className="contact-error">{error}</span>
                )}
                </label>
                <input type="password" name="password" value={password} onChange={handleChange} className="contact-input" />
                <div className="submit-area">
                <button type="submit" disabled={isLoading} className="call-to-action contact-submit">
                        Anmelden
                </button>
                {
                    success && (
                    <p className="contact-success">Nachricht gesendet!</p>
                    )
                }
                </div>
            </form>
        </div>       
    )
}

export default AdminLogin;